// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Tournament Rewards Tab CSS Module
 * Styles for tournament prizes and rewards display
 * Aligned with PrizePop/CampaignTable styling
 */
.XepRWR6OLlY8x2xMpUKZ {
  width: 100%;
  max-width: var(--campaign-tab-width);
  margin: 0 auto 10px;
  flex: 1;
  overflow-y: auto;
}
.Xz2WXJwhoEUuW52hw8tt {
  height: 100%;
  width: 100%;
  position: relative;
  display: block;
}
.V_8aQelOnm5Lfj_ULEOc {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  top: 0px;
  visibility: visible;
}
.Y3R9UnpduvzTnbnkczuc {
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding-bottom: 8px;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
}
.nV2F7gk9kmTJYFO8uGdV {
  overflow-y: auto;
  background-color: #1c1c1e;
  border-radius: 12px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  width: 100%;
  height: calc(100% - var(--navigation-height));
  max-height: 60dvh;
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.5);
  border: 1.5px solid #272727;
  box-sizing: border-box;
}
@media (max-height: 968px) {
  .nV2F7gk9kmTJYFO8uGdV {
    max-height: 400px;
  }
}
.nV2F7gk9kmTJYFO8uGdV::-webkit-scrollbar {
  display: none;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (orientation: portrait) and (max-color:2147477350) {
  .nV2F7gk9kmTJYFO8uGdV {
    border-radius: 8px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (orientation: portrait) and (color:2147477350) {
  .nV2F7gk9kmTJYFO8uGdV {
    border-radius: 8px;
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/variants/tournaments/tabs/RewardsTab/TournamentRewardsTab.module.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;EACxB,WAAW;EACX,6CAA6C;EAC7C,iBAAiB;EACjB,0CAA0C;EAC1C,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,aAAa;AACf;AACA;AAAA;EACE;IACE,kBAAkB;EACpB;AACF;AAAA;AAJA;AAAA;AAAA;AAAA;EACE;IACE,kBAAkB;EACpB;AACF;AAAA;AAAA;AAAA","sourcesContent":["/**\n * Tournament Rewards Tab CSS Module\n * Styles for tournament prizes and rewards display\n * Aligned with PrizePop/CampaignTable styling\n */\n.tournamentRewardsTabContainer {\n  width: 100%;\n  max-width: var(--campaign-tab-width);\n  margin: 0 auto 10px;\n  flex: 1;\n  overflow-y: auto;\n}\n.loaderContainer {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  display: block;\n}\n.contentContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  position: relative;\n  top: 0px;\n  visibility: visible;\n}\n.topPrizesContainer {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  padding-bottom: 8px;\n  justify-content: space-between;\n  align-items: baseline;\n  width: 100%;\n}\n.prizesList {\n  overflow-y: auto;\n  background-color: #1c1c1e;\n  border-radius: 12px;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  width: 100%;\n  height: calc(100% - var(--navigation-height));\n  max-height: 60dvh;\n  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.5);\n  border: 1.5px solid #272727;\n  box-sizing: border-box;\n}\n@media (max-height: 968px) {\n  .prizesList {\n    max-height: 400px;\n  }\n}\n.prizesList::-webkit-scrollbar {\n  display: none;\n}\n@media (orientation: portrait) and (--campaign-mobile) {\n  .prizesList {\n    border-radius: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tournamentRewardsTabContainer": `XepRWR6OLlY8x2xMpUKZ`,
	"loaderContainer": `Xz2WXJwhoEUuW52hw8tt`,
	"contentContainer": `V_8aQelOnm5Lfj_ULEOc`,
	"topPrizesContainer": `Y3R9UnpduvzTnbnkczuc`,
	"prizesList": `nV2F7gk9kmTJYFO8uGdV`
};
export default ___CSS_LOADER_EXPORT___;
